import { render, staticRenderFns } from "./ExpressProblemTableMobile.vue?vue&type=template&id=bfc09dd6&scoped=true"
import script from "./ExpressProblemTableMobile.vue?vue&type=script&lang=js"
export * from "./ExpressProblemTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc09dd6",
  null
  
)

export default component.exports